import { useTranslation } from 'react-i18next';

import { Content } from '../../../models/content/types';
import FeedHeader, { FeedHeaderProps } from './feed-header';

import './content-layouts.scss';
import { FeedCardWithData } from '../../content/solar-feed-card/solar-feed-card';

type ContentLayoutRow = FeedHeaderProps & {
  contents: Content[];
  description?: string;
  feedUrl: string;
  viewAllText: string;
  isFetching: boolean;
  minLength: number;
  isTopic: boolean;
};

const ContentLayoutRow = ({
  id,
  title,
  description,
  viewAllText,
  feedUrl,
  isFetching,
  minLength,
  contents,
  analyticsData,
  isTopic = false,
}: ContentLayoutRow) => {
  const { t } = useTranslation();

  const MAX_ITEMS = 3;
  const displayedContents = contents.slice(0, MAX_ITEMS);

  if (!isFetching && displayedContents.length < minLength) return null;

  // Note: Placeholder not implimented when fetching

  return (
    <>
      <FeedHeader
        id={id}
        title={title}
        description={description}
        viewAllLink={feedUrl}
        viewAllText={viewAllText || `${t('assistant.view_all')} ${title}`}
        isTopic={isTopic}
        analyticsData={analyticsData}
      ></FeedHeader>
      <div className={'content-layout__row'}>
        {displayedContents.map((content, idx) => (
          <div className={'content-layout__row-card'} key={idx}>
            <FeedCardWithData
              content={content}
              analyticsData={analyticsData}
              compact
              fullHeight
              layout="vertical"
              titleHeadingLevel={2}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default ContentLayoutRow;
